import React from 'react';
import ReactDOM from 'react-dom';
import "./scss/component.scss";
import App from "./App";
//import {BrowserRouter} from "react-router-dom";
ReactDOM.render(
	<App />,
	document.getElementById("root")
);